<div class="text-medium-title-button">
  <h3 class="col-xl-4">{{header}}</h3>
  <div class="pt-deci">
    <ng-content></ng-content>
  </div>
  <div class="pt-mega ">
    <a class="btn btn-bordered" [href]="linkHref" target="_blank">{{button}}</a>
  </div>
</div>
